import { createContext } from 'react';

export const Context = createContext<() => Promise<void>>(() => Promise.resolve());
